import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productPartNumbersStyles } from "@dana/Overrides/Components/ProductPartNumbers";
import { productInformationStyles } from "@dana/Overrides/Widgets/ProductList/ProductListProductInformation";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { StyledTypography } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { css } from "styled-components";

productInformationStyles.container = mergeToNew(productInformationStyles.container, {
    gap: 0,
    css: css`
        flex-grow: 0;
        margin-bottom: auto;
    `,
});

productInformationStyles.partNumbersStyles = mergeToNew(productInformationStyles.partNumbersStyles, {
    erpNumberValueText: {
        variant: "h3",
        color: themeColors.primary.danaBlue,
        css: css`
            margin-bottom: 8px;
        `,
    },
});
productPartNumbersStyles.productDetailLink = mergeToNew(productPartNumbersStyles.productDetailLink, {
    typographyProps: {
        color: themeColors.primary.danaBlue,
        underline: false,
        css: css`
            margin-bottom: 8px;
            text-decoration: none;
        `,
    },
});
productInformationStyles.descriptionStyles = mergeToNew(productInformationStyles.descriptionStyles, {
    productDetailLink: {
        typographyProps: {
            lineHeight: lineHeights.defaultLarge,
            size: fontSizes.medium,
            underline: false,
            color: themeColors.primary.richBlack,
        },
        css: css`
            ${StyledTypography} {
                color: ${themeColors.primary.richBlack};
            }
        `,
    },
    productDetailDescription: {
        css: css`
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
});

productInformationStyles.productInfoHeader = mergeToNew(productInformationStyles.productInfoHeader, {
    css: css`
        display: flex;
        align-items: flex-start;
        column-gap: 16px;
        margin-bottom: 8px;
    `,
});

productInformationStyles.brandGridItem = mergeToNew(productInformationStyles.brandGridItem, {
    css: css`
        flex-basis: 32px;
        max-width: 32px;
        flex-shrink: 0 !important;
        padding: 0;
        max-height: 32px;
    `,
});

productInformationStyles.partNumbersGridItem = mergeToNew(productInformationStyles.partNumbersGridItem, {
    css: css`
        padding: 0;
    `,
});

productInformationStyles.descriptionGridItem = mergeToNew(productInformationStyles.descriptionGridItem, {
    css: css`
        padding: 0;
        min-height: 40px;
        max-height: 40px;
    `,
});
